export default "__VITE_ASSET__21734e98__"